import { RefCodeService } from '../model/ref-code.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { RefCode } from 'assets-model';
import { Observable } from 'rxjs';


export class RefCodeDataSource extends CrudDataSource<RefCode> {

  constructor(private service: RefCodeService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<RefCode>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


